import React from 'react';
import moment from 'moment';
import {
  faTag,
  faExchangeAlt,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropdownButton,
  Dropdown
} from 'react-bootstrap';
import PrinterFullEntrega from '../master/imprimir/full.printer';
import utils from '../../utils/utils.functions';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};


const colummnsPaquete = (config, callBackGuia, callBackEntrega, callBackEstado, callBackTracking, showPrefixGuide) => {
  return [
    {
      name: 'Registrado',
      selector: 'createdAt',
      sortable: true,
      width: '10%',
      wrap: true,
      cell: row => (
        moment(row.createdAt).format('DD/MM/YYYY')
      )
    },
    {
      name: 'Guia',
      selector: 'guia',
      sortable: true,
      width: '10%',
      cell: (row) => (
       <div>{showPrefixGuide ? row.prefijo_tipo_salida : config.prefijo_correlativo_guia}-{row.guia}</div>
      )
    },
    {
      name: 'Estado',
      sortable: true,
      width: '10%',
      cell: (row) => (
        <div>
         {
          row.anulado === 1 && !row.guia_finalizada ? <span className="badge badge-danger">ANULADO</span>
          :!row.anulado && row.guia_finalizada ? <span className="badge badge-success">ENTREGADO</span>
          :!row.anulado && !row.guia_finalizada && row.guia_pendiente ? <span className="badge badge-primary">RESERVADA</span> 
          : <span className="badge badge-warning">TRANSITO</span>  
         }
        </div>
      )
    },
    {
      name: 'Cliente',
      selector: row => row.nombre_cliente,
      sortable: true,
      wrap: true,
      width: '20%',
      cell: row => (
        <div className="flex-column">
        <small>{row.rut}</small>
        <div>{row.nombre_cliente.toUpperCase()}</div>
        </div>
      )
    },
    {
      name: 'Tipo',
      selector: row => row.tipo_salida,
      sortable: true,
    },
    {
      name: 'Pago',
      selector: row => row.monto_pago || 0,
      sortable: true,
      cell: row => (
        utils.formatMoney(row.monto_pago || 0)
      )
    },
    {
      name: 'Sucursal',
      selector: row => row.nombre_sucursal,
      sortable: true,
    },
    {
      right: true,
      name: 'Acciones',
      cell: (row) => (
        <div className="mt-2 mb-2">
        <DropdownButton  size="sm" variant="secondary" title="Opciones">
          <Dropdown.Item onClick={() => callBackGuia(row)}> 
            <FontAwesomeIcon icon={faTag} /> Ver detalle
          </Dropdown.Item>
          <Dropdown.Item  disabled={row.guia_finalizada || row.anulado || row.guia_pendiente } onClick={() => callBackEntrega(row)}> 
            <FontAwesomeIcon icon={faExchangeAlt} /> Entregar
          </Dropdown.Item>
          <Dropdown.Item  disabled={row.guia_finalizada || row.anulado || row.guia_pendiente } onClick={() => callBackEstado(row)}> 
            <FontAwesomeIcon icon={faExchangeAlt} /> Cambiar Estado
          </Dropdown.Item>
          <PrinterFullEntrega 
              disabled={row.guia_finalizada || row.anulado || row.guia_pendiente }
              masterId={row.id}
              campo="guia_id"
              texto="Orden de entrega"
              showPrefixGuide={showPrefixGuide}
          />
          <Dropdown.Item disabled={false} onClick={() => callBackTracking(row)}>
              <FontAwesomeIcon icon={faFileAlt} /> Tracking
          </Dropdown.Item>
        </DropdownButton>
        </div>
      )
    }
  ];
}


const tableGuia = {
  customStyles,
  colummnsPaquete,
}

export default tableGuia;